import * as React from 'react';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Navigate,
    Route,
    RouterProvider,
} from 'react-router-dom';
import HomePage from '@pages/HomePage';
import ProjectView from '@widgets/project-view/ProjectView';
import Profile from '@pages/UserProfile/Profile';
import { SignUpPage } from '@pages/SignUpPage';
import ProtectedRoute from '@hoc/ProtectedRoute';
import { SignInPage } from '@pages/SignInPage/SignInPage';
import { ResetPassWordPage } from '@pages/ResetPassWordPage';
import ProjectsLoaderWrapper from '@hoc/ProjectsLoaderWrapper';
import { NewPasswordPage } from '@pages/NewPasswordPage/NewPasswordPage';
import { useMaasRoutes } from './MaasModeRoutes';
import { useRoadsRoutes } from './RoadNetworkEditorModeRoutes';
import { useTransitRoutes } from './PublicTransitEditorModeRoutes';
import { useBiDashboardsRoutes } from './BiModeRoutes';
import { useConfigurationRoutes } from './ConfigModeRoutes';
import { useRunsRoutes } from './RunsModeRoutes';
import { useLayersRoutes } from './LayersWithKeplerModesRoutes';
import { useEvInfrastructureRoutes } from './EvInfrastructureModeRoutes';
import { useLogisticsRoutes } from './LogisticsModeRoutes';
import { useScenarioPresetsRoutes } from './ScenarioPresetsModeRoutes';
import LazyLoadingWrapper from '@components/LazyLoadingWrapper/LazyLoadingWrapper';
import { useReadmeRoutes } from './ProjectHomeModeRoutes';

const SuperSetAnonymousWindowDashboard = React.lazy(
    () => import('@features/anonymous-window-dashboard/SuperSetAnonymousWindowDashboard')
);

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/">
            <Route
                path="/:projectId/dashboard/:runId/:dashboardId/sdashboard"
                element={<LazyLoadingWrapper element={<SuperSetAnonymousWindowDashboard />} />}
            />
            <Route element={<ProtectedRoute />}>
                <Route element={<ProjectsLoaderWrapper />}>
                    <Route index element={<HomePage />} />
                    <Route path="/:projectId/*" element={<ProjectView />}>
                        {useReadmeRoutes()}
                        {useLayersRoutes()}
                        {/*{useAlgorithmsRoutes()}*/}
                        {useBiDashboardsRoutes()}
                        {useRoadsRoutes()}
                        {useTransitRoutes()}
                        {useMaasRoutes()}
                        {useLogisticsRoutes()}
                        {useConfigurationRoutes()}
                        {useRunsRoutes()}
                        {useEvInfrastructureRoutes()}
                        {useScenarioPresetsRoutes()}
                    </Route>
                    <Route path="settings">
                        <Route path="profile" element={<Profile />} />
                    </Route>
                </Route>
            </Route>
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/reset-password" element={<ResetPassWordPage />} />
            <Route path="/new-password" element={<NewPasswordPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
    )
);

export const AppRoutes = () => {
    return <RouterProvider router={router} />;
};
